module.exports = __webpack_public_path__ + "static/media/deleteIcon.4cbecbaf.svg";